import React, { FC } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import { PARAMETER_PATH, SIMULATION_TOOL_PATH } from '../../constants';
import ParameterSettingListingPage, { parameterFilterKeys } from './List/ParameterSettingListingPage';
import ParameterSettingDetailPage from './Create/ParameterSettingDetailPage';

const ParameterManagementPage: FC<RouteComponentProps> = ({ history }) => {
  return (
    <Switch>
      <Redirect
        exact
        from={`${SIMULATION_TOOL_PATH}${PARAMETER_PATH}`}
        to={`${SIMULATION_TOOL_PATH}${PARAMETER_PATH}/list`}
      />
      <PruRoute
        exact
        path={`${SIMULATION_TOOL_PATH}${PARAMETER_PATH}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={parameterFilterKeys}>
            <ParameterSettingListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute exact path={`${SIMULATION_TOOL_PATH}${PARAMETER_PATH}/edit/:id`} component={ParameterSettingDetailPage} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default ParameterManagementPage;
